<div class="bciti-table-grey">
  <!-- Loading overlay for when data exists but is reloading (e.g., language change) -->
  <div class="loading-overlay" *ngIf="loading && dataSource.data.length > 0">
    <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
  </div>
  
  <table class="table" #serviceTable mat-table [dataSource]="dataSource">
      <!-- Role Name Column -->
      <ng-container matColumnDef="roleName">
          <th class="table-header" mat-header-cell *matHeaderCellDef>
              {{ 'access_control.list.role_name' | translate }}
          </th>
          <td class="table-name" mat-cell *matCellDef="let element">
              <span>{{ element.title }}</span>
          </td>
      </ng-container>

      <!-- Module Column -->
      <ng-container matColumnDef="module">
          <th class="table-header" mat-header-cell *matHeaderCellDef>
              {{ 'access_control.list.module' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
              <ng-container *ngIf="element.permissions && element.permissions.length > 0">
                  <button 
                      class="module-dropdown-trigger"
                      [matMenuTriggerFor]="moduleMenu">
                      <span class="module-dropdown-value">{{ getModuleDisplayText(element.permissions) }}</span>
                      <mat-icon class="module-dropdown-arrow">keyboard_arrow_down</mat-icon>
                  </button>
                  <mat-menu #moduleMenu="matMenu" class="module-dropdown-panel">
                      <div *ngFor="let permission of element.permissions" class="module-menu-item">
                          {{ permission }}
                      </div>
                  </mat-menu>
              </ng-container>
              <ng-container *ngIf="!element.permissions || element.permissions.length === 0">
                  <span class="no_modules">No modules</span>
              </ng-container>
          </td>
      </ng-container>

      <!-- Users Column -->
      <ng-container matColumnDef="users">
          <th class="table-header" mat-header-cell *matHeaderCellDef>
              {{ 'access_control.list.user' | translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="users-cell">
              <div class="users-display" (click)="openUserMenu(element)">
                  <div class="user-avatars" *ngIf="element.users && element.users.length > 0">
                      <img 
                          *ngFor="let user of element.users.slice(0, 3)" 
                          [src]="getUserAvatarUrl(user)"
                          [alt]="user.picture"
                          class="user-avatar">
                      <span *ngIf="element.users.length > 3" class="user-count">+{{ element.users.length - 3 }}</span>
                  </div>
                  <span class="user-text" *ngIf="element.users.length === 0">{{ 'access_control.list.no_users' | translate }}</span>
                  <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
              </div>
          </td>
      </ng-container>

      <!-- Action Column -->
      <ng-container matColumnDef="action">
          <th class="table-header" mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" class="action-col">
              <button 
                  class="desktop-table-button bciti-button bciti-button--invisible"
                  aria-label="Open"
                  [matMenuTriggerFor]="actionMenu">
                  <i class="icon-more-vertical"></i>
              </button>
              <mat-menu 
                  #actionMenu="matMenu"
                  class="bciti-table-dropdown bciti-table-dropdown--actions"
                  xPosition="before">
                  <button 
                      mat-menu-item
                      *ngFor="let item of actionMenuOptions"
                      class="bciti-table-dropdown-option bciti-table-dropdown-option--actions"
                      (click)="handleClick(item.eventEmitterTag, element)">
                      <span>{{ item.label }}</span>
                  </button>
              </mat-menu>
          </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnKeys"></tr>
      <tr *matRowDef="let row; columns: columnKeys; let rowIndex = index" mat-row></tr>
      <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="columnKeys.length">
              <div class="empty-table-cell-content">
                  <mat-progress-spinner 
                      *ngIf="loading"
                      mode="indeterminate"
                      diameter="40">
                  </mat-progress-spinner>
                  <span *ngIf="!loading">No Access Control</span>
              </div>
          </td>
      </tr>
  </table>

  <mat-paginator 
      class="paginator"
      showFirstLastButtons
      [length]="dataSource.data.length"
      [pageSizeOptions]="[5, 10, 25, 50]"
      [pageSize]="10">
  </mat-paginator>
</div>

<!-- User Menu Modal -->
<div class="user-menu-overlay" *ngIf="showUserMenu" (click)="closeUserMenu()">
  <div class="user-menu-modal" (click)="$event.stopPropagation()">
      <div class="user-menu-header">
          <span class="user-role-name">{{ selectedRole?.title }}</span>
          <button class="close-button" (click)="closeUserMenu()">
              <mat-icon>close</mat-icon>
          </button>
      </div>

      <div class="user-menu-content">
          <!-- Add User Section -->
          <div class="add-user-section">              
              <div class="add-user-form">
                  <div class="input-group" style="display: flex; flex-direction: column; gap: 1rem;">
                    <button
                          *ngIf="hideSearch"
                          class="bciti-button bciti-button--black"
                          (click)="showSearch()">
                          <span *ngIf="!loading">
                            {{ 'access_control.list.add' | translate }}
                          </span>
                          <span *ngIf="loading">
                            {{ 'access_control.list.assigning' | translate }}
                          </span>
                        </button>
                        <div *ngIf="!hideSearch" class="search-row">
                            <app-search-dropdown
                              [mode]="'single'"
                              class="search-dropdown"
                              [roleId]="selectedRole?._id"
                              (usersSelected)="onUsersSelected($event)">
                            </app-search-dropdown>
                            
                            <button
                              class="bciti-button bciti-button--black"
                              (click)="addUser()"
                              [disabled]="selectedUsers.length === 0 || loading">
                              <span *ngIf="!loading">
                                {{ 'access_control.list.confirm' | translate }}
                              </span>
                              <span *ngIf="loading">
                                {{ 'access_control.list.assigning' | translate }}
                              </span>
                            </button>
                          </div>
                  </div>
                  <br>
                  <div class="selected-users-preview" *ngIf="selectedUsers.length > 0">
                      <span class="assign-user">{{ 'access_control.list.users_to_assign' | translate }}:</span>
                      <div class="user-chips">
                              <app-user-chip
                                *ngFor="let user of selectedUsers; trackBy: trackByUserId"
                                [user]="user"
                              >
                              </app-user-chip>
                      </div>
                  </div>
              </div>
          </div>

          <!-- Users List -->
          <div class="users-section">
              <h3>{{ 'access_control.list.user_assign' | translate }}</h3>
              <div class="users-list" *ngIf="selectedRole?.users.length > 0">
                  <div 
                      class="user-item"
                      *ngFor="let user of selectedRole?.users"
                      >
                      <div class="user-info">
                          <img 
                              [src]="getUserAvatarUrl(user)"
                              [alt]="user?.picture"
                              class="user-avatar-large">
                              <div class="user-details">
                                <div class="user-name-email">
                                  <span class="user-name">{{ user.firstName }} {{ user.lastName }}</span>
                                  <span class="user-email">{{ user.email }}</span>
                                </div>
                              </div>
                      </div>
                      <button 
                          class="remove-user-button"
                          (click)="removeUser(user._id, selectedRole._id)"
                          aria-label="Remove user">
                          <mat-icon>delete_outline</mat-icon>
                      </button>
                  </div>
              </div>
          <div *ngIf="selectedRole?.users.length === 0">
            <span>{{ 'access_control.list.no_user_yet' | translate }}</span>
          </div>
          </div>
      </div>
  </div>
</div>